import config from 'baseConfig/pg/v2/refunds';

import {
  INITIATED_REFUNDS,
  BATCH_REFUNDS,
  AUTO_REFUNDS,
} from 'baseConfig/pg/v2/constants';

export default {
  [INITIATED_REFUNDS]: {
    TABLE_COLUMNS: [
      ...config[INITIATED_REFUNDS].TABLE_COLUMNS,
    ],
    FILTER_ITEMS: { ...config[INITIATED_REFUNDS].FILTER_ITEMS },
    SEARCH_ITEMS: [...config[INITIATED_REFUNDS].SEARCH_ITEMS],
  },
  [BATCH_REFUNDS]: {
    TABLE_COLUMNS: [
      ...config[BATCH_REFUNDS].TABLE_COLUMNS,
    ],
    FILTER_ITEMS: { ...config[BATCH_REFUNDS].FILTER_ITEMS },
    SEARCH_ITEMS: [...config[BATCH_REFUNDS].SEARCH_ITEMS],
  },
  [AUTO_REFUNDS]: {
    TABLE_COLUMNS: [
      ...config[AUTO_REFUNDS].TABLE_COLUMNS,
    ],
    FILTER_ITEMS: { ...config[AUTO_REFUNDS].FILTER_ITEMS },
    SEARCH_ITEMS: [...config[AUTO_REFUNDS].SEARCH_ITEMS],
  },
};
